// src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7f5fb0", // Your purple brand color
      contrastText: "#FFFFFF", // White text for contrast
    },
    secondary: {
      main: "#9575CD", // Lighter purple accent
    },
    background: {

    },
  },
  typography: {
    fontFamily: "Verdana,Arial, sans-serif", 
    button: {
      textTransform: "none", 
    },
  },
    MuiDrawer: {
      styleOverrides: {
        paper: {
        //   backgroundColor: "#512DA8", // Sidebar background purple
        //   color: "#FFFFFF", // White text in sidebar
        },
      },
    },
    
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    fontWeight: 400,
                    fontSize: "15px",
                    borderRadius: 10,
                    minHeight: 44,
                    padding: "10px 20px",
                    boxShadow: "none",
                    transition: "all 0.2s ease-in-out",
                },

                contained: {
                    background: "linear-gradient(90deg, #774def, #774def)",
                    color: "#fff",

                    "&:hover": {
                        background:
                            "linear-gradient(90deg, #774def, #774def)",
                        boxShadow: "0 4px 12px rgba(25,118,210,0.3)",
                    },

                    "&:disabled": {
                        background: "#bdbdbd",
                        color: "#f5f5f5",
                    },
                },

                outlined: {
                    borderWidth: "1.5px",

                    "&:hover": {
                        borderWidth: "1.5px",
                    },
                },
            },
        },
    },

});

export default theme;